/* Rosée — native JS: drawers, AJAX cart, variants, predictive search, wishlist stub. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const live = (msg) => { const el = $('#LiveRegion'); if (el) el.textContent = msg; };
  const root = window.Shopify?.routes?.root || '/';

  /* Dialog open/close (native <dialog>: focus trap + Esc built in) */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open]');
    if (open) {
      const d = document.getElementById(open.dataset.open);
      if (!d) return;
      if (open.dataset.open === 'CartDrawer' && document.body.dataset.cartType !== 'drawer') return;
      e.preventDefault(); d.showModal();
      $('input[type=search]', d)?.focus();
    }
    if (e.target.closest('[data-close]')) e.target.closest('dialog')?.close();
    if (e.target.matches('dialog[open]')) { // backdrop click
      const r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });

  /* Cart drawer refresh via Section Rendering API */
  async function refreshCart(openDrawer) {
    const res = await fetch(`${root}?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('#CartDrawer', html);
    const cur = $('#CartDrawer');
    if (fresh && cur) {
      const wasOpen = cur.open;
      cur.innerHTML = fresh.innerHTML;
      if (openDrawer && !wasOpen) cur.showModal();
    }
    const count = (await (await fetch(`${root}cart.js`)).json()).item_count;
    $$('[data-cart-count]').forEach((c) => { c.textContent = count; c.hidden = count === 0; });
  }

  /* AJAX add to cart (product page + quick add) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    if (document.body.dataset.cartType !== 'drawer') return; // fall back to normal submit → cart page
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    btn.setAttribute('aria-disabled', 'true');
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok) { live(data.description || data.message || 'Could not add this item.'); const err = $('[data-form-error]', form); if (err) err.textContent = data.description || data.message; return; }
      await refreshCart(true);
      live('Added to cart');
    } finally { btn.removeAttribute('aria-disabled'); }
  });

  /* Cart line changes */
  async function changeLine(line, quantity) {
    await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
    if ($('[data-cart-page]')) { location.reload(); return; }
    await refreshCart(false);
  }
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove]');
    if (rm) { changeLine(+rm.dataset.remove, 0); return; }
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      const next = Math.max(+input.min || 0, (+input.value || 0) + +step.dataset.qtyStep);
      input.value = next;
      if (input.dataset.line) changeLine(+input.dataset.line, next);
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-line]')) changeLine(+e.target.dataset.line, +e.target.value);
    const sort = e.target.closest('[data-auto-submit]');
    if (sort) sort.closest('form').requestSubmit();
  });

  /* Variant picker: re-render price + buy button for the selected variant (Section Rendering) */
  document.addEventListener('change', async (e) => {
    const fs = e.target.closest('[data-variant-form]');
    if (!fs || !e.target.matches('.chips input')) return;
    const form = e.target.closest('form');
    const variants = JSON.parse($('[data-variants]', form.closest('[data-product]')).textContent);
    const chosen = $$('.option', form).map((o) => $('input:checked', o)?.value);
    const match = variants.find((v) => v.options.every((val, i) => val === chosen[i]));
    const sid = form.closest('[data-section-id]').dataset.sectionId;
    if (!match) { $$('[data-buy]', form.closest('[data-product]')).forEach((b) => { const x = b.querySelector('button'); if (x) { x.disabled = true; x.textContent = 'Unavailable'; } }); return; }
    form.querySelector('[name=id]').value = match.id;
    const url = new URL(location.href); url.searchParams.set('variant', match.id); history.replaceState({}, '', url);
    const res = await fetch(`${url.pathname}?variant=${match.id}&section_id=${sid}`);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    ['[data-price]', '[data-buy]', '[data-sticky-buy]'].forEach((sel) => {
      const next = $(sel, doc), cur = $(sel);
      if (next && cur) cur.innerHTML = next.innerHTML;
    });
    if (match.featured_media) { const t = $(`[data-thumb="${match.featured_media}"]`); t?.click(); }
  });

  /* Product gallery thumbnails */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    const main = $('[data-gallery-main]');
    const img = $('img', t);
    $$('[data-thumb]').forEach((b) => b.removeAttribute('aria-current'));
    t.setAttribute('aria-current', 'true');
    main.innerHTML = `<img src="${t.dataset.large}" srcset="${t.dataset.srcset}" sizes="(min-width:900px) 50vw, 100vw" alt="${img.alt}" width="${img.width}" height="${img.height}">`;
  });

  /* Sticky add-to-cart on mobile */
  const buy = $('[data-buy]');
  const sticky = $('.sticky-atc');
  if (buy && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting), { rootMargin: '0px 0px -10% 0px' }).observe(buy);
  }

  /* Predictive search */
  const pInput = $('[data-predictive]');
  if (pInput) {
    let t, ctrl;
    const out = $('#PredictiveResults');
    pInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = pInput.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        ctrl?.abort(); ctrl = new AbortController();
        try {
          const res = await fetch(`${root}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,article,collection&resources[limit]=6&section_id=predictive-search`, { signal: ctrl.signal });
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          out.innerHTML = $('#shopify-section-predictive-search', doc)?.innerHTML || '';
        } catch (_) {}
      }, 250);
    });
  }

  /* Wishlist: integration-friendly stub (localStorage). Dispatches 'rosee:wishlist' so an app can hook in. */
  const KEY = 'rosee_wishlist';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (_) { return []; } };
  const sync = () => { const l = read(); $$('[data-wishlist]').forEach((b) => b.setAttribute('aria-pressed', l.includes(b.dataset.handle))); };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist]'); if (!b) return;
    let l = read(); const h = b.dataset.handle;
    l = l.includes(h) ? l.filter((x) => x !== h) : [...l, h];
    try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (_) {}
    sync(); document.dispatchEvent(new CustomEvent('rosee:wishlist', { detail: { handle: h, list: l } }));
  });
  sync();

  /* Recently viewed (product pages record, section reads) */
  const rv = $('[data-product-handle]');
  if (rv) { try { let l = JSON.parse(localStorage.getItem('rosee_rv')) || []; l = [rv.dataset.productHandle, ...l.filter((x) => x !== rv.dataset.productHandle)].slice(0, 8); localStorage.setItem('rosee_rv', JSON.stringify(l)); } catch (_) {} }
  const rvBox = $('[data-recently-viewed]');
  if (rvBox) {
    let l = []; try { l = (JSON.parse(localStorage.getItem('rosee_rv')) || []).filter((h) => h !== rvBox.dataset.exclude).slice(0, +rvBox.dataset.limit || 4); } catch (_) {}
    if (l.length) {
      Promise.all(l.map((h) => fetch(`${root}products/${h}?view=card`).then((r) => (r.ok ? r.text() : '')))).then((cards) => {
        const html = cards.join('');
        if (html.trim()) { $('[data-rv-grid]', rvBox).innerHTML = html; rvBox.hidden = false; sync(); }
      });
    }
  }
  /* Related products: Product Recommendations API rendered through the section */
  const recs = $('[data-recs-url]');
  if (recs) {
    fetch(recs.dataset.recsUrl).then((r) => (r.ok ? r.text() : '')).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sec = $('.section', doc);
      if (sec) { recs.replaceWith(sec); sync(); }
    }).catch(() => {});
  }
  /* Transparent header turns solid after scrolling */
  const hdr = $('.header--overlay');
  if (hdr) { const t = () => hdr.classList.toggle('is-solid', window.scrollY > 20); t(); window.addEventListener('scroll', t, { passive: true }); }
})();
